import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import { CircularProgress, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import MessageView from '../components/view/MessageView'
import {
  cleanSuccess,
  getCommunicationsById,
  updateCommunication,
  updateMessage,
  respondMessages
} from '../store/communications/actions'

const mapStateToProps = ({ auth, communications, school }) => {
  return {
    userId: auth.user.data?.id,
    userOccuppations: auth.user.data?.attributes?.occupations,
    isFetching: communications.isFetching,
    currentCommunication: communications.currentItem || {},
    communicationSuccess: communications.isSuccess,
    communicationUpdateSuccess: communications.isUpdateSuccess,
    selectedSchoolItem: school.selectedItem
  }
}

const mapDispatchToProps = {
  cleanSuccess,
  getCommunicationsById,
  updateCommunication,
  updateMessage,
  respondMessages
}

const useStyles = makeStyles(theme => ({
  root: {
    width: '98%'
  }
}))

const MessagePage = ({
  currentCommunication,
  getCommunicationsById,
  updateCommunication,
  isFetching,
  match,
  userOccuppations,
  updateMessage,
  respondMessages,
  communicationSuccess,
  communicationUpdateSuccess,
  cleanSuccess,
  selectedSchoolItem,
  userId
}) => {
  const classes = useStyles()
  const { communicationId } = match.params
  useEffect(
    () => {
      getCommunicationsById({ id: communicationId })
    },
    [communicationId, communicationUpdateSuccess]
  )
  const hasAccessOnlyToHistory = ['46']
  const projectId = process.env.REACT_APP_PROJECT_ID.toString()

  if (isFetching) return <CircularProgress color='secondary' />

  return (
    <Paper className={classes.root} elevation={0}>
      <MessageView
        hasAccessOnlyToHistory={hasAccessOnlyToHistory}
        projectId={projectId}
        communicationSuccess={communicationSuccess}
        currentCommunication={currentCommunication}
        userOccuppations={userOccuppations}
        updateCommunication={updateCommunication}
        updateMessage={updateMessage}
        respondMessages={respondMessages}
        cleanSuccess={cleanSuccess}
        userId={userId}
        selectedSchool={selectedSchoolItem}
      />
    </Paper>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(MessagePage)
